(function () {
    clientApp.controller('paymentsCtrl', function ($scope, $q, ngDialog, Client, Service, $http, usSpinnerService) {
        $scope.services = Service.query();
        $scope.addServiceModel = null;
        $scope.serviceToAdd = null;
        $scope.comment = '';
        $scope.selection = [];
        $scope.processPayment = function (clientId, transactionId) {
            $scope.client = Client.get({'clientId': clientId});
            var transactionRequest = $http.get(Routing.generate('app_account_transaction_gettransaction', {id: transactionId}));
            var recentDistributions = $http.get(Routing.generate('app_account_transaction_getrecentdistributions', {id: transactionId}));

            $q.all(
                [
                    $scope.services.$promise,
                    $scope.client.$promise,
                    transactionRequest,
                    recentDistributions
                ]
            ).then(function (values) {
                $scope.transaction = values[2].data;
                $scope.recentDistributions = values[3].data;

                $scope.client.services = $.grep($scope.client.services, function (e) {
                    return e.active;
                });

                var userRole = $("body").data('user-role');
                var roles = $("body").data('user-roles');
                if (roles.includes('ROLE_HEAD_MANAGER')) {
                    angular.forEach($scope.client.services, function (val, i) {
                        $scope.client.services[i].can_add_gifts = true;
                    });
                }

                angular.forEach($scope.client.services, function (service) {
                    if (service.paid == 0) {
                        // service.beginDate = new Date();
                    }
                });

                var dialog = ngDialog.open(
                    {
                        template: 'services.html',
                        scope: $scope,
                        closeByDocument: false,
                        width: 900
                    }
                );

                dialog.closePromise.then(function () {
                    window.location.reload();
                });

                usSpinnerService.stop('loading');
            });
        };

        $scope.addServiceModal = function () {
            $scope.addServiceDialog = ngDialog.open(
                {
                    template: 'addService.html',
                    scope: $scope,
                    closeByDocument: false
                }
            );
        };

        $scope.addChildServiceModal = function (service) {
            var allowedServices = [];
            angular.forEach(service.service.allowed_slave_services, function (e) {
                allowedServices.push(e.id);
            });

            $scope.serviceToAdd = service;
            $scope.allowedServices = allowedServices;

            if (!$scope.selection[service.id]) {
                $scope.selection[service.id] = service.actual_children_services;

                $scope.selection[service.id] = $scope.selection[service.id].filter(function (item) {
                    return $scope.allowedServices.indexOf(item.id) > -1;
                }).map(function (item) {
                    return item.id;
                });
            }

            $scope.addServiceDialog = ngDialog.open(
                {
                    template: 'addChildService.html',
                    scope: $scope,
                    closeByDocument: false
                }
            );
        };

        $scope.addGiftServiceModal = function (service) {
            $scope.serviceToAdd = service;
            $scope.addServiceDialog = ngDialog.open(
                {
                    template: 'addGiftService.html',
                    scope: $scope,
                    closeByDocument: false
                }
            );
        };

        $scope.$watch('addServiceModel', function (val, oldVal) {
            if (val) {
                $scope.newServiceCost = val.cost;
                $scope.newServicePeriod = val.duration_name;
            }
        }, true);

        $scope.addService = function (service) {
            if (!service) {
                return;
            }

            $http.post(
                Routing.generate('app_service_servicerest_addservice', {
                    client: $scope.client.id,
                    service: service.id
                }),
                {
                    'cost': $scope.newServiceCost,
                    'payingPeriod': $scope.newServicePayingPeriod,
                    'contract': $scope.contract ? $scope.contract.id : null
                }
            ).then(function (response) {
                var data = response.data;
                if (data.success) {
                    // data.item.beginDate = new Date();

                    if (data.item.service.category === 8 || data.item.service.category === 6) {
                        data.item.beginDate = new Date();
                    }

                    data.item.visible = true;
                    $scope.client.services.push(data.item);
                    $scope.addServiceDialog.close();
                } else {
                    alert(data.errors.join("\n"));
                }
            });
        };

        $scope.toggleSelection = function toggleSelection(service, parentServiceId) {
            var idx = $scope.selection[parentServiceId].indexOf(service.id);

            if (idx > -1) {
                $scope.selection[parentServiceId].splice(idx, 1);
            } else {
                $scope.selection[parentServiceId].push(service.id);
            }
        };

        $scope.addChildServices = function (clientService) {

            var selectedServices = $scope.selection[clientService.id];

            if (selectedServices.length > $scope.serviceToAdd.service.slave_services_count_required) {
                $scope.serviceToAdd.errors = 'У услуги "' + clientService.service.name + '" должно быть не больше ' + $scope.serviceToAdd.service.slave_services_count_required + $scope.translateErrors($scope.serviceToAdd.service.slave_services_count_required);
                return false;
            } else {
                $scope.serviceToAdd.errors = false;
            }

            if (selectedServices.length === 0) {
                return;
            }

            $scope.addServiceDialog.close();
            $http.post(
                Routing.generate('app_service_servicerest_addchildservice', {
                    clientService: clientService.id,
                }),
                {
                    'services': selectedServices
                }
            ).then(function (response) {
                if (response.data.success) {
                    var allowedServices = Object.values($scope.serviceToAdd.service.allowed_slave_services);

                    var existServices = clientService.service.children_services;

                    var addedServiceNames = allowedServices.filter(function (item) {
                        return selectedServices.indexOf(item.id) > -1;
                    });

                    Array.prototype.push.apply(addedServiceNames, existServices);

                    addedServiceNames = addedServiceNames.map(function (item) {
                        return item.name + ' ' + item.cost + ' р.'
                    });

                    $scope.serviceToAdd.all_children_service_names = addedServiceNames.join(', ');
                }
            });
        };

        $scope.addGiftService = function (service) {
            if (!service) {
                return;
            }

            $http.post(
                Routing.generate('app_service_servicerest_addgiftservice', {
                    clientService: $scope.serviceToAdd.id,
                    service: service.id
                })
            ).then(function (response) {
                $scope.addGiftError = null;

                if (response.data.error) {
                    $scope.addGiftError = response.data.error;
                    return;
                }

                if (response.data.success) {
                    $scope.serviceToAdd.gift_service_names += ($scope.serviceToAdd.gift_service_names ? ', ' : '') + service.name + ' ' + service.cost + ' р.';
                    $scope.addServiceDialog.close();
                }
            });
        };

        $scope.process = function () {
            var sum = 0;
            var data = [];
            angular.forEach($scope.client.services, function (service) {
                if (service.toAllocate) {
                    sum += parseInt(service.toAllocate);
                    data.push(
                        {
                            'id': service.id,
                            'sum': service.toAllocate,
                            'beginDate': service.beginDate
                        }
                    );
                }
            });

            if (sum > $scope.transaction.deposit) {
                $scope.error = 'Введенная сумма больше суммы платежа';
                return;
            } else if (sum <= 0 || sum === undefined) {
                $scope.error = 'Введите сумму';
                return;
            }

            $scope.error = null;

            usSpinnerService.spin('loading');

            $http.post(
                Routing.generate('app_service_servicerest_processpayment'),
                {
                    data: data,
                    transaction: $scope.transaction.id,
                    comment: $scope.comment
                }
            ).then(function (response) {
                $scope.error = null;
                $scope.errors = null;
                $scope.successes = null;

                if (response.data.messages.successes) {
                    $scope.successes = response.data.messages.successes;
                }

                if (response.data.error) {
                    $scope.error = response.data.error;
                    usSpinnerService.stop('loading');
                    return;
                }

                if (response.data.messages.errors) {
                    $scope.errors = response.data.messages.errors;
                    usSpinnerService.stop('loading');
                    return;
                }

                $scope.client = Client.get({'clientId': $scope.client.id});
                $http.get(Routing.generate('app_account_transaction_gettransaction', {id: $scope.transaction.id})).then(function (responce) {
                    $scope.comment = '';
                    $scope.transaction = responce.data;
                    angular.forEach($scope.client.services, function (service) {
                        if (service.paid == 0) {
                            // service.beginDate = new Date();
                        }
                    });

                    $http
                        .get(Routing.generate('app_account_transaction_getrecentdistributions', {id: $scope.transaction.id}))
                        .then(function (responce) {
                            $scope.recentDistributions = responce.data;

                            usSpinnerService.stop('loading');
                        });
                });
            });
        };

        $scope.stopService = function (clientService) {
            if (confirm('Прекратить услугу')) {
                $http
                    .post(Routing.generate("app_service_servicerest_stopservice", {id: clientService.id}))
                    .then(function (response) {
                        if (!response.data.success) {
                            alert(response.data);
                        }

                        clientService.is_stopped = true;
                    });
            }
        };

        // $scope.transactionDelete = function (clientTransactionId) {
        //     if (confirm('Отменить транзакцию?')) {
        //         usSpinnerService.spin('loading');
        //         $http
        //             .post(Routing.generate('app_account_transaction_deleteclienttransaction', {id: clientTransactionId}))
        //             .then(
        //                 function (response) {
        //                     if (!response.data.success) {
        //                         alert(response.data);
        //                     }
        //
        //                     var transactionRequest = $http.get(Routing.generate('app_account_transaction_gettransaction', {id: $scope.transaction.id}));
        //                     var recentDistributions = $http.get(Routing.generate('app_account_transaction_getrecentdistributions', {id: $scope.transaction.id}));
        //                     $scope.client = Client.get({'clientId': $scope.client.id});
        //
        //                     $q.all(
        //                         [
        //                             transactionRequest,
        //                             recentDistributions,
        //                             $scope.client.$promise
        //                         ]
        //                     ).then(function (values) {
        //                         $scope.transaction = values[0].data;
        //                         $scope.recentDistributions = values[1].data;
        //
        //                         usSpinnerService.stop('loading');
        //                     });
        //                 }
        //             );
        //     }
        // };

        $scope.allowedServiceFilter = function (service) {
            return $scope.allowedServices.indexOf(service.id) !== -1;
        };

        $scope.translateErrors = function (number) {
            if (number == 1) {
                return ' подчиненной услуги';
            } else {
                return ' подчиненных услуг';
            }
        };
    });
})();
